var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoodGoodIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#FED7AA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 16.2773C15.625 15.1555 16.5344 14.2461 17.6562 14.2461C18.7781 14.2461 19.6875 15.1555 19.6875 16.2773V20.3398C19.6875 21.4617 18.7781 22.3711 17.6562 22.3711C16.5344 22.3711 15.625 21.4617 15.625 20.3398V16.2773Z",
    fill: "#4C555F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6875 16.2773C32.6875 15.1555 33.5969 14.2461 34.7188 14.2461C35.8406 14.2461 36.75 15.1555 36.75 16.2773V20.3398C36.75 21.4617 35.8406 22.3711 34.7188 22.3711C33.5969 22.3711 32.6875 21.4617 32.6875 20.3398V16.2773Z",
    fill: "#4C555F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3246 28.8768C11.9465 27.9536 12.3775 26.8934 13.2876 26.5094C13.5112 26.4158 13.743 26.3711 13.9713 26.3711C14.6704 26.3711 15.3339 26.7907 15.6187 27.4881C17.2696 31.5249 21.3585 34.1319 26.036 34.1319C30.6077 34.1319 34.6729 31.523 36.3921 27.4838C36.7833 26.5655 37.8332 26.1422 38.7368 26.5401C39.6405 26.938 40.0566 28.0037 39.6654 28.9214C37.3808 34.2872 32.0303 37.754 26.0354 37.754C19.9121 37.754 14.5301 34.2703 12.3246 28.8768Z",
    fill: "#4C555F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoodGoodIcon);
export default __webpack_public_path__ + "static/media/MoodGoodIcon.0e05e4eef823028b84941250e2412fb1.svg";
export { ForwardRef as ReactComponent };